type VehicleDetail = {
  cylinderArrangement: string | null
  chargerType: string | null
  valvesPerCylinder: number | null
  roofLoad: string
  length: string
  width: string
  height: string
  wheelSize: null | string
  totalWeight: string
  curbWeight: string
  trunkCapacityMax: number | unknown
  trunkCapacityMed: number | unknown
  trunkCapacityMin: number | unknown
  autonomousLevelBase: null | unknown
  batteryType: string | null
  startSupport: boolean
  startStopSystem: boolean
  batteryCapAH: number | null
  batteryCapkWH: number | null
  pollutionNorm: null | unknown
  driveType: null | unknown
  engineType: string | null
  mixtureFeedSystem: string | null
  exhaustTreatmentSystem: string | null
  topSpeed: number | null
  acceleration: string | null
  tankRange: number | null
  consUrb: string
  consLand: string
  consOverall: string
  co2Emision: string
  tyreFront: string | null
  tyreRear: string | null
  typeSpare: string | null
  numberOfBatteries: number | null
  chargeCycles: number | null
  chargeTime: number | null
  make: string
  normalVersion: string
  modelExt: string
  version: string | null
  versionExt: string | null
  bodyType: string
  energy: string
  engineCapacity: number | null
  numberOfDoors: number | null
  numberOfGears: number | null
  numberOfSeats: number | null
  numberOfCylinders: number | null
  powerKw: number | null
  powerHp: number | null
  taxHp: number | null
  productionDateBegin: string | null
  productionDateEnd: string | null
  productionYears: string | null
  transmission: string | null
  segment1: string | null
  segment2: string | null
  newPriceExcVat: string
  newPriceIncVat: string
  id: string | null
}
const defaultVehicleDetail: VehicleDetail = {
  cylinderArrangement: '',
  chargerType: '',
  valvesPerCylinder: 0,
  roofLoad: '',
  length: '',
  width: '',
  height: '',
  wheelSize: '',
  totalWeight: '',
  curbWeight: '',
  trunkCapacityMax: 0,
  trunkCapacityMed: 0,
  trunkCapacityMin: 0,
  autonomousLevelBase: null,
  batteryType: null,
  startSupport: false,
  startStopSystem: false,
  batteryCapAH: 0,
  batteryCapkWH: 0,
  pollutionNorm: null,
  driveType: '',
  engineType: '',
  mixtureFeedSystem: '',
  exhaustTreatmentSystem: '',
  topSpeed: 0,
  acceleration: '',
  tankRange: 0,
  consUrb: '',
  consLand: '',
  consOverall: '',
  co2Emision: '',
  tyreFront: '',
  tyreRear: '',
  typeSpare: '',
  numberOfBatteries: 0,
  chargeCycles: 0,
  chargeTime: 0,
  make: '',
  normalVersion: '',
  modelExt: '',
  version: '',
  versionExt: '',
  bodyType: '',
  energy: '',
  engineCapacity: 0,
  numberOfDoors: 0,
  numberOfGears: 0,
  numberOfSeats: 0,
  numberOfCylinders: 0,
  powerKw: 0,
  powerHp: 0,
  taxHp: 0,
  productionDateBegin: '',
  productionDateEnd: '',
  productionYears: '',
  transmission: null,
  segment1: '',
  segment2: '',
  newPriceExcVat: '',
  newPriceIncVat: '',
  id: '',
}

export type { VehicleDetail }
export { defaultVehicleDetail }
